import { Guid } from "@/Common/Models/Guid";
import { FlowsheetEventHistory } from "../Models/FlowsheetEventHistory";
import { FlowsheetSummary } from "../Models/FlowsheetSummary";

export class FlowsheetHistoryHelper {
    public static latestEventByEmployee(flowsheet: FlowsheetSummary): Record<Guid, FlowsheetEventHistory> {
        return flowsheet.EventHistory.reduce((acc, event) => {
            const { EmployeeId, EventDate } = event;
            if (!acc[EmployeeId] || acc[EmployeeId].EventDate < EventDate) {
                acc[EmployeeId] = event;
            }
            return acc;
        }, {} as Record<Guid, FlowsheetEventHistory>);
    }
}
